/*
Copyright (c) 2025 Mathilde Meyer, Naziha Beghdadi
Licensed under the MIT License (see LICENSE.txt file for details)
*/

/*
This project uses vis-timeline (MIT License)
https://github.com/visjs/vis-timeline

Copyright (c) 2014-2017 Almende B.V. and contributors
Copyright (c) 2017-2019 vis.js contributors

Licensed under the MIT License.
See the LICENSE-vis.txt file in this project for full license text.
 */

/*
This project uses html2canvas (MIT License)
https://github.com/niklasvh/html2canvas

Copyright (c) 2012 Niklas von Hertzen

Licensed under the MIT License.
See the LICENSE-html2canvas.txt file in this project for full license text.
*/

/*
This project uses jszip (MIT License)
https://github.com/Stuk/jszip

Copyright (c) 2009-2016 Stuart Knightley, David Duponchel, Franz Buchinger, António Afonso

Licensed under the MIT License.
See the LICENSE-jszip.txt file in this project for full license text.
*/

/*
This project uses MUI (MIT License)
https://github.com/mui/material-ui

Copyright (c) 2014 Call-Em-All

Licensed under the MIT License.
See the LICENSE-mui.txt file in this project for full license text.
*/

/*
This project uses html2canvas (MIT License)
https://github.com/open-xml-templating/docxtemplater

Copyright (c) Edgar HIPP

Licensed under the MIT License.
See the LICENSE-docxtemplater.txt file in this project for full license text.
*/

/*
This project uses docx (MIT License)
https://github.com/dolanmiu/docx

Copyright (c) 2016 Dolan

Licensed under the MIT License.
See the LICENSE-docx.txt file in this project for full license text.
*/

/*
This project uses FileSaver (MIT License)
https://github.com/eligrey/FileSaver.js

Copyright © 2016 Eli Grey.

Licensed under the MIT License.
See the LICENSE-Filesaver.txt file in this project for full license text.
*/

import "./styles/style.css";
import "./styles/ripple-override.css";
import React, { useState } from "react";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
//import Navbar from "./components/Navbar";
import Introduction from "./components/pages-flow/Introduction";
//import Icons from "./components/Icons";

function App() {
  //const [currentPage, setCurrentPage] = useState("form");
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [forceReset, setForceReset] = useState(false);


  const handleSaveProject = (projectName, projectData) => {
    // Tu peux gérer une sauvegarde locale ici si besoin
    console.log("Projet sauvegardé :", { projectName, projectData });
  };


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div>
        {/*<Navbar
          onNavigate={handleNavigate}
          onHomeClick={() => {
            if (currentPage === "form") {
              setShowConfirmDialog(true);
            } else {
              setForceReset(true);
              setCurrentPage("form");
            }
          }}
        />
        {currentPage === "form" && */}
        {(<Introduction
            showConfirmDialog={showConfirmDialog}
            onConfirmDialogClose={(confirmed) => {
              setShowConfirmDialog(false);
              if (confirmed) {
                setForceReset(true);
              }
            }}
            forceReset={forceReset}
            onForceResetHandled={() => setForceReset(false)}
            onSaveProject={handleSaveProject}
            projectToEdit={null}
          />
        )}
        {/*{currentPage === "icons" && <Icons />}*/}
      </div>
    </ThemeProvider>
  );
}

export default App;
